module.exports = __webpack_public_path__ + "img/header-he.e00310e7.jpg";